import React from "react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useTranslations } from '../../../locales/useTranslations';
import FadeInAnimation from "../../Common/FadeInAnimation";

const WordpressVerständnisundErfahrungfürIhreBranche = () => {
    const { t } = useTranslations();

    const renderIndustrySection = (industryKey, isOpen = false) => {
        const sections = [
            { key: 'services', items: 4 },
            { key: 'marketing', items: 4 },
            { key: 'legal', items: 4 }
        ];

        if (industryKey === 'associations') {
            sections[0] = { key: 'management', items: 4 };
            sections[1] = { key: 'communication', items: 4 };
            sections[2] = { key: 'financing', items: 4 };
        } else if (industryKey === 'sme') {
            sections[0] = { key: 'processes', items: 4 };
            sections[1] = { key: 'marketing', items: 4 };
            sections[2] = { key: 'scalability', items: 4 };
        } else if (industryKey === 'private') {
            sections[0] = { key: 'portfolio', items: 4 };
            sections[1] = { key: 'blog', items: 4 };
            sections[2] = { key: 'ecommerce', items: 4 };
        }

        return (
            <details open={isOpen}>
                <summary className="wp-industries__accordion-summary">
                    {t(`wordpressDevelopment_industries_${industryKey}_title`)}
                </summary>
                <div className="wp-industries__accordion-content">
                    <FadeInAnimation direction="bottom" delay={100}>
                        <p className="wp-industries__accordion-content-text">
                            {t(`wordpressDevelopment_industries_${industryKey}_description`)}
                        </p>

                        <div className="row wp-industries__feature-row">
                            {sections.map((section, idx) => (
                                <div key={idx} className="col-md-4 mb-3">
                                    <div className="wp-industries__feature-card">
                                        <h5 className="wp-industries__feature-title">
                                            {t(`wordpressDevelopment_industries_${industryKey}_${section.key}_title`)}
                                        </h5>
                                        <ul className="wp-industries__feature-list">
                                            {[...Array(section.items)].map((_, i) => (
                                                <li key={i} className="wp-industries__feature-item">
                                                    • {t(`wordpressDevelopment_industries_${industryKey}_${section.key}_items_${i + 1}`)}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </FadeInAnimation>
                </div>
            </details>
        );
    };

    return (
        <section className="ptb-100 wp-industries">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="wp-industries__decoration"></div>

            <div className="container wp-industries__container">
                <div className="section-titles text-center mb-5 wp-industries__header">
                    <div className="wp-industries__badge">
                        {t('wordpressDevelopment_industries_subtitle')}
                    </div>
                    <h2 className="wp-industries__title">
                        {t('wordpressDevelopment_industries_title')}
                    </h2>
                    <div className="wp-industries__intro-card">
                        <p className="wp-industries__intro-text">
                            {t('wordpressDevelopment_industries_description')}
                        </p>
                        <p className="wp-industries__intro-text">
                            {t('wordpressDevelopment_industries_description2')}
                        </p>
                    </div>
                </div>

                <div className="overview-item wp-industries__accordion-wrapper">
                    <div className="container max-width-600">
                        <div className="native-accordion">
                            {renderIndustrySection('doctors', true)}
                            {renderIndustrySection('associations')}
                            {renderIndustrySection('sme')}
                            {renderIndustrySection('private')}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WordpressVerständnisundErfahrungfürIhreBranche;
